import { render, staticRenderFns } from "./DiscountField.vue?vue&type=template&id=04031643&"
import script from "./DiscountField.vue?vue&type=script&lang=js&"
export * from "./DiscountField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04031643')) {
      api.createRecord('04031643', component.options)
    } else {
      api.reload('04031643', component.options)
    }
    module.hot.accept("./DiscountField.vue?vue&type=template&id=04031643&", function () {
      api.rerender('04031643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/DiscountField.vue"
export default component.exports